import React, {Component} from 'react';
import {connect} from 'react-redux';

import BannerV from "../../components/banner/BannerV";
import MerchantsCatList from "../../components/merchants/MerchantsCatList";
import HowItWorks from "../../components/howItWorks/HowItWorks";

import "./home.css";


class Home extends Component {
    render() {
        return (
            <div>
                {/*<Banner />*/}
                <BannerV/>

                <section className="w-100" style={{background:"#f6581d"}}>
                    <div className="d-flex justify-content-between">
                        <div className="p2"/>
                        <div className="p2">
                            <h4 className="font-weight-bold mt-3 mb-3 white-text">پیشنهاد شگفت انگیز به مدت محدود</h4>
                        </div>
                        <div className="p2"/>
                    </div>
                </section>
                <div className="clearfix"/>

                <section className="w-100" style={{background:"#ebebeb"}}>
                    <MerchantsCatList />
                </section>
                <div className="clearfix"></div>
                <section className="w-100" >
                    <HowItWorks />
                </section>
                <div className="clearfix"></div>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(
    mapStateToProps,
)(Home);



// WEBPACK FOOTER //
// ./src/containers/home/Home.js